import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as StartDestinationActions from '../actions/start-destination.actions';
import {DestinationsService} from '../../../services/api/destinations/destinations.service';
import * as DestinationsActions from '../actions/destinations.actions';
import {MatSnackBar} from '@angular/material/snack-bar';
import {UUID} from '../../../shared/types/uuid.type';
import {Destination} from '../../../services/api/destinations/destination.model';


@Injectable()
export class StartDestinationEffects {

  // noinspection JSUnusedGlobalSymbols
  startDestination$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StartDestinationActions.startDestination),
      concatMap((payload: { id: UUID }) =>
        this.destinationsService.startDestination(payload.id).pipe(
          map((data: Destination) => StartDestinationActions.startDestinationSuccess({data})),
          catchError((error: any) => of(StartDestinationActions.startDestinationFailure({error}))))
      )
    );
  });

  // noinspection JSUnusedGlobalSymbols
  startDestinationSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StartDestinationActions.startDestinationSuccess),
      tap(() => this.snackBar.open('Destination started successfully', 'Success', {duration: 3000})),
      map(() => DestinationsActions.loadDestinations())
    );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly snackBar: MatSnackBar,
    private readonly destinationsService: DestinationsService
  ) {
  }

}
